module.exports = __webpack_public_path__ + "img/kettle-bell-1.a29cbc12.jpg";